import { useEffect, useState } from "react";
import { Bell, Check } from "lucide-react";
import { PageHeader, EmptyState } from "@/components/common";
import { StatusPill } from "@/components/StatusPill";
import { api } from "@/lib/api";
import { elapsed } from "@/lib/format";

const TYPE_LABEL = {
  CONTROL_LATE: "Control atrasado", CONTROL_MISSED: "Control omitido",
  OUT_OF_RANGE: "Fuera de rango", RECHECK_REQUIRED: "2ª medición requerida",
  INCIDENT_OPEN: "Incidencia abierta", INCIDENT_REOPENED: "Incidencia reabierta",
};

export default function Alertas() {
  const [alerts, setAlerts] = useState([]);

  const load = () => api.get("/alerts").then(({ data }) => setAlerts(data)).catch(() => setAlerts([]));
  useEffect(() => { load(); }, []);

  const markRead = async (id) => { await api.post(`/alerts/${id}/read`); load(); };

  return (
    <div>
      <PageHeader title="Alertas" subtitle="Eventos que requieren seguimiento" />
      {alerts.length === 0 ? (
        <EmptyState icon={Bell} title="Sin alertas" subtitle="No hay alertas registradas." />
      ) : (
        <div className="space-y-3">
          {alerts.map((a) => (
            <div key={a.id} data-testid={`alert-${a.id}`} className={`flex items-center gap-3 rounded-2xl border bg-white p-4 ${a.status === "NEW" ? "border-red-200" : "border-slate-200"}`}>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <StatusPill status={a.type === "OUT_OF_RANGE" ? "OUT_OF_RANGE" : "NEW"} label={TYPE_LABEL[a.type] || a.type} />
                  {a.status !== "NEW" && <StatusPill status="READ" />}
                </div>
                <p className="mt-1.5 font-medium">{a.title}</p>
                <p className="text-sm text-slate-500">{a.message}</p>
                <p className="mt-0.5 text-xs text-slate-400">{elapsed(a.created_at)}</p>
              </div>
              {a.status === "NEW" && (
                <button data-testid={`alert-read-${a.id}`} onClick={() => markRead(a.id)} className="grid h-9 w-9 place-items-center rounded-full hover:bg-slate-100" title="Marcar leída">
                  <Check className="h-4 w-4 text-slate-500" />
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
